export { default } from './components/capslock.indicator';
